import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import validateSsncode from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError } from '../../data/actions';

/**
 * Ssncode field wrapper. It handles validation for a 5-digit integer Ssncode.
 */
const SsncodeField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const validationApiRateLimited = useSelector(state => state.register.validationApiRateLimited);

  const { handleErrorChange, professionType } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const fieldError = validateSsncode(value, professionType, formatMessage);
    if (fieldError) {
      handleErrorChange('last_five_digits_of_social_security_number', fieldError);
    } else if (!validationApiRateLimited) {
      // You may want to dispatch some other action related to ssncode if necessary
    }
  };

  const handleOnFocus = () => {
    handleErrorChange('last_five_digits_of_social_security_number', '');
    dispatch(clearRegistrationBackendError('last_five_digits_of_social_security_number'));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

SsncodeField.defaultProps = {
  errorMessage: '',
};

SsncodeField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  professionType: PropTypes.string.isRequired,
};

export default SsncodeField;
